if (!customElements.get('product-features')) {
  customElements.define(
    'product-features',
    class ProductFeatures extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        // Events
        subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.onVariantChange.bind(this));
      }

      fetchOptions(optionValues) {
        const productInfo = document.querySelector('product-info');
        const url = productInfo.dataset.url;
        const sectionID = this.dataset.section;
        fetch(`${url}?section_id=${sectionID}&option_values=${optionValues.join(',')}`)
          .then((response) => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector('product-features');

            if (newContent) {
              this.innerHTML = newContent.innerHTML;
            } else {
              console.warn('Product features not found in fetched HTML.');
            }
          })
          .catch((error) => {
            console.error('Error updating product features:', error);
          });
      }

      onVariantChange({ data: { event, target, selectedOptionValues } }) {
        this.fetchOptions(selectedOptionValues);
      }
    }
  );
}
